import React, { PropsWithChildren } from "react";
import "./CardAlert.scss";
import Button from "../button/button";

const DEFAULT_ICON_URL =
    "https://images.ctfassets.net/203frbsx1z3n/3me4UiL6WU9ZlQjxtv3AGc/5a045743eaf9c5df0a76b9fd92ce4c87/Grupo_16830.svg";

type CardAlertProps = PropsWithChildren<{
    title: string;
    classname?: string;
    iconUrl?: string;
    btnText?: string;
    href?: string;
    onClickAction?: () => void;
}>;

const CardAlert = ({
    iconUrl = DEFAULT_ICON_URL,
    title,
    classname = "",
    children,
    href,
    onClickAction,
    btnText = "Entendido",
}: CardAlertProps) => {
    return (
        <div className={`a-card-alert ${classname}`} role="alert">
            <section className="a-card-alert__icon">
                <img src={iconUrl} alt="Icono de la alert" />
            </section>

            <h4 className="a-card-alert__title">{title}</h4>
            <section className="a-card-alert__description">{children}</section>
            <section>
                <Button
                    self
                    type={href ? "link" : "button"}
                    href={href}
                    classname={`a-button__magenta_aceleradora big center`}
                    text={btnText}
                    isDisabled={false}
                    onClickAction={onClickAction}
                ></Button>
            </section>
        </div>
    );
};

export default CardAlert;
